var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-body",class:[_vm.isEmoji(_vm.text) ? 'emoji-show' : '', _vm.senderType == 'user' ? '' : 'color-theme-default'],domProps:{"innerHTML":_vm._s(_vm.escapedText)}})}
var staticRenderFns = []

export { render, staticRenderFns }